import { countryIsoCodes } from '@toasttab/buffet-pui-country-utilities'

export const mapCountry = (country?: string) => {
  return countryIsoCodes.find((supportedCode) => supportedCode === country)
}
